import { LegacyRef } from "react";

export function ViewerNameField({
  option,
  inputRef,
}: {
  option: ViewerNameFieldOption;
  inputRef: LegacyRef<HTMLInputElement>;
}) {
  const label = option.label || "ニックネーム";
  return (
    <div className="py-4 px-2">
      <div className="text-gray-800 text-md font-bold mb-1 flex items-center">
        <span className="font-normal text-xs px-2 rounded-full bg-red-600 mr-2 text-white">
          必須
        </span>

        <span className="flex-1">{label}</span>
      </div>
      {option.helperText && (
        <p className="text-sm text-gray-700">
          {/* 本名/ニックネーム/匿名可 */}
          {option.helperText}
        </p>
      )}
      <input
        type="text"
        name="name"
        className="appearance-none block w-full bg-gray-100 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
        ref={inputRef}
        data-test="nickname-field"
      />
    </div>
  );
}
